<template>
  <div>
    <Banner theme="orange">
      <template v-slot:title> Custom Components </template>
      <template v-slot:description />
      <template v-slot:image>
        <img
          src="@/assets/banners/widgets/custom-components.svg"
          alt="Custom Components"
        />
      </template>
    </Banner>

    <IndexPageActions
      :sort-list="sortList"
      btn-text="New Custom Component"
      btn-to="/dev-tools/custom-components/new"
      :sort-by.sync="sortBy"
      search-placeholder="Search Components"
      :search-text.sync="searchText"
    />

    <div v-if="list">
      <CustomComponentsDataTable
        v-if="computedList.length"
        :list="computedList"
        @destroy="destroy"
      />
      <div v-else class="no-entries">No Custom Components</div>
    </div>
    <Spinner v-else relative />
  </div>
</template>

<script>
import IndexPage from '../index-page';
import CustomComponentsDataTable from '@/components/dataview/custom-components.datatable';

export default {
  name: 'WidgetCustomComponentsPage',
  components: { CustomComponentsDataTable },
  extends: IndexPage,
  methods: {
    async fetchList() {
      const { data } = await this.$api.CustomComponent.get({
        sort_by: this.sortBy,
      });
      this.list = data;
    },
    async destroy(item) {
      const confirmed = await this.$confirm({ title: 'Are you sure?' });
      if (!confirmed) return;
      await this.$api.CustomComponent.destroy({ id: item.id });
      this.list = this.list.filter((t) => t.id != item.id);
    },
  },
};
</script>

<style scoped lang="scss"></style>
